import { useEffect } from 'react';
import Lenis from 'lenis';
import Background from './Components/Background';
import CustomCursor from './Components/CustomCursor';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import About from './Components/About';
import Projects from './Components/Projects';
import Skills from './Components/Skills';
import Experience from './Components/Experience';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, duration: 1.2 });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    const id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div style={{ background: '#06080f', minHeight: '100vh', position: 'relative' }}>
      <Background />
      <CustomCursor />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Navbar />
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Experience />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
